<script>
import Testimonials from '@/components/atomic/templates/Testimonials.vue';
import { mapActions } from 'vuex';
import axios from 'axios';
export default {
  components: {
    Testimonials,
  },
  name: 'Detalhes',
  data() {
    return {
      avaliacoes: [
        {
          id: '',
          img: require('@/assets/avatar/avatar.svg'),
          name: 'Luís Carlos',
          date: '03 Fev 2021, 10:26 PM',
          comment:
            'Apesar de eu ter realmente demorado a chegar no fim, é um bom curso. O instrutor passa por todas as etapas do processo de criação e explica cada um deles claramente.',
        },
        {
          id: '',
          img: require('@/assets/avatar/avatar.svg'),
          name: 'Luís Carlos',
          date: '03 Fev 2021, 10:26 PM',
          comment:
            'Apesar de eu ter realmente demorado a chegar no fim, é um bom curso. O instrutor passa por todas as etapas do processo de criação e explica cada um deles claramente.',
        },
        {
          id: '',
          img: require('@/assets/avatar/avatar.svg'),
          name: 'Luís Carlos',
          date: '03 Fev 2021, 10:26 PM',
          comment:
            'Apesar de eu ter realmente demorado a chegar no fim, é um bom curso. O instrutor passa por todas as etapas do processo de criação e explica cada um deles claramente.',
        },
        {
          id: '',
          img: require('@/assets/avatar/avatar.svg'),
          name: 'Luís Carlos',
          date: '03 Fev 2021, 10:26 PM',
          comment:
            'Apesar de eu ter realmente demorado a chegar no fim, é um bom curso. O instrutor passa por todas as etapas do processo de criação e explica cada um deles claramente.',
        },
      ],
      course: {},
      modules: [],
    };
  },
  computed: {
    ...mapActions('name', []),
  },
  async mounted() {
    let courseName = this.$route.params.courseName;
    console.log('hanga', courseName);
    this.$store.state.courses.course.name = courseName;
    await axios
      .get(
        `${process.env.VUE_APP_API}/courses/${this.$store.state.courses.course.id}`
      )
      .then(response => {
        console.log('aqui', response.data);
        this.course = response.data.courses[0];
        this.modules = response.data.modules;
      })
      .cath(error => console.log('aqui', error));
  },
  methods: {},
};
</script>

<template>
  <el-row
    type="flex"
    style="flex-direction: column; width: 100vw; justify-content: center"
  >
    <div style="margin-bottom: 80px"><Auth /></div>
    <div
      style="
        color: #fff;
        background-color: #1c1d1f;
        max-width: 100%;
        margin: auto;
      "
    >
      <el-row
        type="flex"
        class="row-bg"
        justify="center"
        style="padding: 1.2rem; width: 100vw;"
      >
        <el-col :span="12">
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              height: auto;
            "
          >
            <div
              style="
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center !important;
              "
              class="grid-content bg-purple"
            >
              <h1>{{ course.name || 'Estrutura de Dados em C' }}</h1>
              <p style="text-align: justify; margin-left: 40px; width: 70%;">
                <br />
                Curso de JavaScript e TypeScript do básico ao avançado -
                Atualizado para 2022 - O curso mais completo sobre todas as
                nuances do JavaScript você você vai encontrar na atualidade.
                Aprenda Javascript moderno (ES6+) para front-end (com Webpack,
                babel, React, React Hooks, Redux, HTML5, CSS3 e mais) e back-end
                (com Node, Express, MySQL / MariaDB, MongoDB, PostgreSQL,
                Next.Js, Strapi e mais) e se torne um(a) desenvolvedor(a) full
                stack. Este curso inclui JavaScript e TypeScript, você vai
                aprender ambas as linguagens no mesmo pacote. Fundamentos
                Inicialmente, o aluno aprenderá a utilizar recursos nativos do
                JavaScript sem a necessidade de utilizar frameworks ou
                bibliotecas adicionais (Javascript puro, conhecido como Vanilla
                JS). Trabalharemos tanto no Node.Js (back-end) quanto no
                navegador (front-end). Node.Js, Frameworks e bibliotecas
                Apresentarei o Node JS, Express e o MongoDB (noSQL) para
                trabalhar com Javascript no Back-end. Apresentarei frameworks e
                bibliotecas que são padrão no mercado atualmente, como Express
                (servidor Web) e Mongoose (para modelar bases de dados MongoDB).
                Também apresentarei em detalhes o sistema de módulos do NodeJS.
              </p>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div
            class=""
            style="display: flex; flex-direction: column; justify-content: center; align-items:center"
          >
            <img src="@/assets/img-course-thumb-default.png" width="60%" />
            <div
              style="
                width: 70%;
                display: flex;
                flex-flow: column wrap;
                align-content: stretch;
                flex-wrap: wrap;
                align-items: center;
              "
            >
              <el-button
                type="primary"
                style="width: inherit;"
                @click="
                  () =>
                    // this.$router.push(
                    //   `/course/${course.userId}/${course.id}/${this.$store.state.courses.course.name}`
                    // )
                    // this.$router.push(
                    //   `${this.$store.state.teacher.name}/curso/${this.$store.state.courses.course.name}/buyCourse`
                    // )
                    this.$router.push(`/teste/buyCourse`)
                "
              >
                <h3>COMPRAR</h3>
              </el-button>
              <el-button style="width: inherit;"
                ><h3>ADCIONAR A LISTA</h3></el-button
              >
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row
      type="flex"
      justify="center"
      style="width: 100vw; flex-direction: column"
    >
      <el-col :span="24" style="margin-top: 20px">
        <h1 style="text-align: center">Mais sobre o Curso<br /></h1>
      </el-col>
      <el-row style="width: 90%; margin: auto" :gutter="50">
        <el-col :span="12">
          <h2 style="text-align: center">Conteudo do Curso</h2>
          <br />
          <el-collapse v-model="activeNames">
            <el-collapse-item
              v-for="(modulo, index) in modules"
              :key="index"
              class="module-header"
              :name="modulo.id"
            >
              <template slot="title">
                <span
                  style="font-size: 20px; font-weight: 600; padding: 2rem"
                  >{{ modulo.name }}</span
                >
              </template>
              <div
                style="padding: .5rem 3rem; font-size: .9rem"
                v-for="(lesson, subIndex) in modulo.lessons"
                :key="subIndex"
              >
                {{ lesson.name }}
                <hr />
              </div>
            </el-collapse-item>
            <!-- <el-collapse-item class="module-header" name="1">
            <template slot="title">
              <span style="font-size: 20px; font-weight: 600; padding: 2rem"
                >MOULO 1</span
              >
            </template>
            <div>
              Consistent with real life: in line with the process and logic of
              real life, and comply with languages and habits that the users are
              used to;
            </div>
          </el-collapse-item> -->
          </el-collapse>
        </el-col>
        <el-col :span="12">
          <h2 style="text-align:center;">
            O que você irá aprender nesse curso
          </h2>
          <br />
          <ul
            style="
                   display: flex;
                  flex-flow: column nowrap;
                  align-content: center;
                  flex-wrap: wrap; "
          >
            <li>
              JavaScript Básico, Funcional e Orientado a Objetos (ES6+,
              front-end e back-end)
            </li>
            <li>
              TypeScript - um superset do JavaScript com tipagem estática
              (front-end e back-end)
            </li>
            <li>Node, Express, MongoDB e MySQL/MariaDB (Back-end)</li>
            <li>Sistema de login com session (front-end e back-end)</li>
            <li>
              Configuração de um servidor Linux para Deploy (Ubuntu Server)
            </li>
            <li>
              Configurações de segurança para o servidor (SSH e TLS - Https)
            </li>
            <li>
              Criação de API Rest com Node + Express + Sequelize (back-end)
            </li>
            <li>Utilização de SQL com sequelize (MySQL e MariaDB)</li>
            <li>Princípios da programação orientada a objetos</li>
            <li>React JS com React Hooks + Redux com Redux Saga (front-end)</li>
          </ul>
        </el-col>
        <el-col
          ><br /><br /><br />
          <Testimonials :testimonials="avaliacoes"
        /></el-col>
      </el-row>
    </el-row>
  </el-row>
</template>

<style lang="scss" scoped>
.part1 {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: flex-start;
  align-content: stretch;
  flex-wrap: nowrap;
}
.module-header {
  background-color: #ccc !important;
}
.el-button + .el-button[data-v-8a4d3aaa] {
  margin-left: 18px;
}
</style>
